import { createFileRoute } from '@tanstack/react-router';

import { TeamTimePage } from '@/pages/team-time/team-time-page';

/**
 * `/teams/:slug/time` — manager-side time report.
 *
 * Behind `time.view_team` (LEAD+ by default).  Anyone without the scope
 * sees a polite "no access" panel via the page's own 403 handling.
 */
export const Route = createFileRoute('/teams/$teamSlug/time')({
  component: TeamTimeRoute,
});

function TeamTimeRoute() {
  return <TeamTimePage />;
}
